import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { note } from '../../techniques/note';
import type { Technique } from '../../techniques.type';

export class NonMusicalTrait extends Trait {
  static baseType = TraitType.NonMusical;
  static baseTitle = 'Non-musical';
  static baseText = 'Removes access to musical techniques.';
  static baseIcon = '';

  type = NonMusicalTrait.baseType;
  title = NonMusicalTrait.baseTitle;
  text = NonMusicalTrait.baseText;
  icon = NonMusicalTrait.baseIcon;

  getTechniques(techniques: Technique[]): Technique[] {
    let index = techniques.findIndex((technique) => technique.tags.includes('song'));
    while (index !== -1) {
      techniques.splice(index, 1);
      index = techniques.findIndex((technique) => technique.tags.includes('song'));
    }
    return [];
  }
}

TraitRegistry.register(NonMusicalTrait.baseType, NonMusicalTrait);
